/**
 * Created by christiancueni on 07/07/16.
 * Copyright (c) 2016 ITerativ GmbH. All rights reserved.
 */

import {SchoolRole} from '../roles/roles.model';

export interface SignupUser {
  schoolName: string;
  firstName: string;
  lastName: string;
  password: string;
  email: string;
  language: string;
}

export interface Credentials {
  username: string;
  password: string;
}

export class Credentials implements Credentials {
  constructor(public username: string, public password: string) {
  }
}

export interface PasswordReset {
  key?: string;
  passwordNew: string;
}

export interface User {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  edulog: boolean;
  data: object;
}

export interface FormUser {
  id?: number;
  first_name: string;
  last_name: string;
  email: string;
  username?: string;
  language?: string;
  school_role?: SchoolRole;
  groups: number[];
  activation_link: string;
  edulog?: boolean;
  data?: object;
}

export interface SemesterData {
  firstStart: string,
  firstEnd: string,
  secondStart: string,
  secondEnd: string,
  thirdStart: string,
  thirdEnd: string,
  names: {
    previous: SemesterName,
    current: SemesterName,
    next: SemesterName
  }
}

export interface SemesterName {
  semester: 0 | 1;
  years: [number, number];
}

export interface UserData {
  username: string;
  id: number;
  role: string;
  email: string;
  language: string;
  isEmailVerified: boolean;
  forcePasswordReset: boolean;
  showEventOnboarding: boolean;
  schoolId: number;
  schoolName: string;
  permissions: string[];
  notificationId: number;
  selectedGroups: number[];
  premium: boolean;
  subscriptionUntil: string;
  schoolAcceptedTerms: boolean;
  semesters: SemesterData,
  showRelationshipOnboarding: boolean;
  edulog: boolean;
}

export interface ProfileUser {
  id: number;
  first_name: string;
  last_name: string;
  email: string;
  language: string;
  username: string;
  oldPassword?: string;
  newPassword?: string;
  school_role?: SchoolRole;
  edulog: boolean;
}

export class ProfileUser {

  public static ADMIN = 'school_admin';
  public static TEACHER = 'teacher';
  public static STUDENT = 'student';
  public static PARENT = 'parent';

  constructor(public id: number,
              public first_name: string,
              public last_name: string,
              public email: string,
              public language: string,
              public username: string,
              public oldPassword?: string,
              public newPassword?: string,
              public school_role?: SchoolRole) {
  }

  static isAdmin(user: ProfileUser) {
    return user.school_role.key === ProfileUser.ADMIN;
  }

  static isTeacher(user: ProfileUser) {
    return user.school_role.key === ProfileUser.TEACHER;
  }
}
